import(/* webpackMode: "eager" */ "/vercel/path0/drift-common/common-ts/lib/clients/DlobWebsocketClient.js");
